import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { resetStep } from '../../../../../features/create-project/create-project-slice'
import { useNavigate } from 'react-router-dom'
import LoadingSpinner from '../../../../../components/LoadingSpinner'
import axios from 'axios'

const ActivateMail = () => {

  const { formData } = useSelector( state => state.setupMail )
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [ loading, setLoading ]  = React.useState(false)

  const sendMail = () => {
    setLoading(true)
    axios.post(`${ process.env.REACT_APP_BASE_URL }/project/email-setup`, formData)
    .then( response => {
        if(response.data.success){                                            
            dispatch( resetStep() )
            setLoading(false)
            navigate('/admin/view-projects')
        }
    })   
  }

  return (
    <>
       <button className='admin-form-btn' onClick={ sendMail }>
             Activate
        </button>
        {  loading && <LoadingSpinner />  }
    </>
  )
}

export default ActivateMail